export default {
  getAiTools(context) {
    if (context.state.aiTools.length > 0) {
      return Promise.resolve(context.state.aiTools);
    }
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/ai-tools`)
        .then(response => {
          context.commit("setAiTools", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  }
};
